import { useMutation } from "react-query";
import { updateSafeType } from "../../../../../actions/Utilities/SafeType";
import { toast } from "components/toastNotification";
import { ISafeType } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateSafeType, safeTypeReFetching } from "../atoms/atoms";

const useEditSafeType = () => {
  const setActionEditState = useSetRecoilState(editStateSafeType);
  const [isReFetching, setIsReFetching] = useRecoilState(safeTypeReFetching);

  const { mutate } = useMutation(
    (newData: ISafeType) => updateSafeType(newData),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire("Updating Safe Type failed", `${res.Message}`, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Safe Type Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Safe Type Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Safe Type failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Safe Type failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Safe Type failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Updating Safe Type failed", `${res}`, "error");
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Safe Type failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditSafeType;
